import React from 'react';
import PropTypes from 'prop-types';
import { Link as LinkRouter } from 'react-router-dom';
import styled from 'styled-components';
import { Breadcrumbs as BreadcrumbsMUI } from '@material-ui/core';
import { FontAwesomeIcon } from '@vr/lib';

const Link = styled(LinkRouter)`
  text-decoration: none;
  color: ${({ theme }) => theme.colors.white};
  font-size: 0.9375rem;
`;
const CurrentLink = styled.span`
  color: ${({ theme }) => theme.colors.white};
  font-size: 0.9375rem;
`;
const ChevronIcon = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.colors.white};
  font-size: 0.8125rem;
  margin: 2px 5px 0;
`;
const LinkIcon = styled(FontAwesomeIcon)`
  margin-right: 13px;
  font-size: 1rem;
`;

export default function Breadcrumbs({ values, ...props }) {
  return (
    <BreadcrumbsMUI
      separator={<ChevronIcon icon={['fas', 'chevron-right']} />}
      aria-label="breadcrumb"
      {...props}
    >
      <Link to="/home">
        <LinkIcon icon={['far', 'home']} />
        Página Inicial
      </Link>
      <CurrentLink>
        <LinkIcon icon={['far', values.icon]} />
        {values.label}
      </CurrentLink>
    </BreadcrumbsMUI>
  );
}

Breadcrumbs.propTypes = {
  values: PropTypes.object.isRequired,
};
